module.exports = __webpack_public_path__ + "media/dashboard/assets/images/no-chat-v4-4841b5f4c82b133d0d0527bcaa201dba.png";